import React, { useState } from 'react';
import { LegalModal } from '../ui/LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-brand-brown text-brand-cream py-12 px-6 text-center" data-id="element-13">
        <div className="max-w-3xl mx-auto" data-id="element-14">
          <h4 className="font-serif text-2xl font-bold mb-4 text-brand-gold" data-id="element-15">
            Salud Dorada
          </h4>
          <p className="text-brand-cream/60 text-sm mb-6" data-id="element-16">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier nuevo régimen de salud.
          </p>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-17">
            <button onClick={() => setPrivacyOpen(true)} className="text-brand-cream/70 hover:text-brand-gold text-sm underline underline-offset-2 transition-colors py-2 px-3" data-id="element-18">
              Política de Privacidad
            </button>
            <span className="text-brand-cream/30" data-id="element-19">|</span>
            <button onClick={() => setTermsOpen(true)} className="text-brand-cream/70 hover:text-brand-gold text-sm underline underline-offset-2 transition-colors py-2 px-3" data-id="element-20">
              Términos y Condiciones
            </button>
          </div>

          <div className="text-brand-cream/40 text-sm" data-id="element-21">
            &copy; {new Date().getFullYear()} Salud Dorada. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-22">
        <h4 className="font-bold text-lg mb-3" data-id="element-23">
          1. Información que Recopilamos
        </h4>
        <p className="mb-4" data-id="element-24">
          Recopilamos la información personal que usted nos proporciona
          directamente, como su nombre, dirección de correo electrónico y datos
          de pago al realizar una compra. No compartimos su información personal
          con terceros, excepto cuando sea necesario para procesar su pedido.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-25">2. Uso de la Información</h4>
        <p className="mb-4" data-id="element-26">
          Utilizamos su información para procesar transacciones, enviar el
          producto digital adquirido, y comunicarnos con usted sobre su compra.
          Podemos enviarle correos electrónicos informativos relacionados con
          salud y bienestar, de los cuales puede darse de baja en cualquier
          momento.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-27">3. Protección de Datos</h4>
        <p className="mb-4" data-id="element-28">
          Implementamos medidas de seguridad para proteger su información
          personal. Todas las transacciones se procesan a través de plataformas
          de pago seguras con encriptación SSL.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-29">4. Cookies</h4>
        <p className="mb-4" data-id="element-30">
          Nuestro sitio web puede utilizar cookies para mejorar su experiencia
          de navegación. Puede configurar su navegador para rechazar cookies,
          aunque esto podría afectar la funcionalidad del sitio.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-31">5. Contacto</h4>
        <p data-id="element-32">
          Si tiene preguntas sobre nuestra política de privacidad, puede
          contactarnos a través de nuestro correo electrónico de soporte.
        </p>
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-33">
        <h4 className="font-bold text-lg mb-3" data-id="element-34">
          1. Aceptación de los Términos
        </h4>
        <p className="mb-4" data-id="element-35">
          Al adquirir el producto "Salud Dorada", usted acepta estos términos y
          condiciones en su totalidad. Si no está de acuerdo con alguna parte de
          estos términos, le pedimos que no realice la compra.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-36">2. Naturaleza del Producto</h4>
        <p className="mb-4" data-id="element-37">
          Salud Dorada es un producto digital educativo e informativo. No
          constituye consejo médico profesional, diagnóstico ni tratamiento.
          Siempre consulte a su médico antes de realizar cambios en su dieta,
          ejercicio o régimen de salud.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-38">3. Entrega del Producto</h4>
        <p className="mb-4" data-id="element-39">
          Al completar su compra, recibirá acceso inmediato al producto digital
          a través del correo electrónico proporcionado. Es su responsabilidad
          asegurarse de que la dirección de correo electrónico sea correcta.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-40">4. Política de Reembolso</h4>
        <p className="mb-4" data-id="element-41">
          Debido a la naturaleza digital del producto, todas las ventas son
          finales. Sin embargo, si experimenta problemas técnicos para acceder
          al contenido, nuestro equipo de soporte le asistirá.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-42">5. Propiedad Intelectual</h4>
        <p className="mb-4" data-id="element-43">
          Todo el contenido de Salud Dorada está protegido por derechos de
          autor. Queda prohibida la reproducción, distribución o reventa del
          material sin autorización expresa.
        </p>

        <h4 className="font-bold text-lg mb-3" data-id="element-44">
          6. Limitación de Responsabilidad
        </h4>
        <p data-id="element-45">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos. El uso del producto es bajo su propia
          responsabilidad y criterio.
        </p>
      </LegalModal>
    </>;
}